import React from 'react';
import { Button } from '@/components/ui/Button';

interface SettingsModalProps {
  open: boolean;
  onClose: () => void;
  reducedMotion: boolean;
  onReducedMotionChange: (checked: boolean) => void;
}

export const SettingsModal: React.FC<SettingsModalProps> = ({
  open,
  onClose,
  reducedMotion,
  onReducedMotionChange,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-xl p-6 w-80 max-w-[90vw]">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-900">⚙️ 설정</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="space-y-4">
          <label className="flex items-center gap-3 cursor-pointer">
            <input
              type="checkbox"
              checked={reducedMotion}
              onChange={(e) => onReducedMotionChange(e.target.checked)}
              className="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
            />
            <div>
              <span className="text-sm font-medium text-gray-700">애니메이션 감소</span>
              <p className="text-xs text-gray-500">저사양 기기에서 성능 향상</p>
            </div>
          </label>
        </div>
        <div className="mt-6 flex justify-end">
          <Button onClick={onClose} size="sm">
            닫기
          </Button>
        </div>
      </div>
    </div>
  );
};

